module.exports = __webpack_public_path__ + "img/7.63d04cba.svg";